module.exports = __webpack_public_path__ + "img/man.9b887eb4.png";